<template>
  <div class="serviceMain">
    <div class="searchBar">
      <div class="tittle"> 我的评价 </div>
      <div class="rightForm">
        <el-input
          v-model="form.workName"
          placeholder="请输入作品名称"
        ></el-input>
        <el-date-picker
          v-model="form.date"
           value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
       <el-button @click="fetchData">查询</el-button>
        <router-link :to="{path:'/Mine/MyRegister'}">
            <el-button type="primary">新增评价</el-button>
        </router-link>
      </div>
    </div>

    <el-table
      :data="tableData"
      :cell-class-name="tabelCellClass"
      style="width: 100%"
      v-loading="isLoading"
    >
      <el-table-column
        prop="workName"
        label="作品名称"
         show-overflow-tooltip
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="orderNo"
        label="订单号"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="createTimeText"
        label="创建时间"
        sortable
        width="170"
      >
        <!-- eslint-disable-next-line -->
        <template slot="header" slot-scope="scope">
          <div class="createTimeHeader">
            <span>创建时间</span>
            <a-tooltip>
              <template slot="title">
                prompt text
              </template>
              <a-icon type="question-circle" />
            </a-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        width="120"
      >
        <template slot-scope="scope">
          <span
            class="stausCell"
            :class="{'stausCell1':scope.row.status=='31',
            'stausCell2':scope.row.status=='40',
            'stausCell3':scope.row.status=='11'|| scope.row.status=='12' || scope.row.status=='13' || scope.row.status=='20',
            'stausCell4':scope.row.status=='10',
            'stausCell5':scope.row.status=='21',}"
          >
            {{scope.row.statusText}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="certificate"
        label="证书"
        width="150"
      >
        <template slot-scope="scope">
          <div class="signList">
            <span :class="{'graySpan':scope.row.status!='21','greenSpan':scope.row.status=='21'}" @click="getRegisterImg(scope.row.orderNo)">
              登 <i class="redBag" v-if="scope.row.status=='21'"> 1 </i>
            </span>
            <span :class="{'graySpan':scope.row.status!='21','greenSpan':scope.row.status=='21'}" @click="getExistImg(scope.row.extra.exist.orderNo)">
              存 <i class="redBag" v-if="scope.row.status=='21'"> 1 </i>
            </span>
            <span :class="{'graySpan':scope.row.status!='21','greenSpan':scope.row.status=='21'}" @click="getEvaluateImg(scope.row.extra.exist.orderNo)">
              评 <i class="redBag" v-if="scope.row.status=='21'"> 1 </i>
            </span>
               <!-- <span
              class="graySpan"
            >
              公
           
            </span> -->
          </div>

        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="120"
        fixed="right"
      >
        <!-- eslint-disable-next-line -->
        <template slot-scope="scope">
          <!-- {{scope.row.status}} -->
       
               <!-- <a-dropdown
            :trigger="['click']"
            placement="bottomLeft"
            overlayClassName="moveLeft"
          >
            <a @click.stop="e => e.preventDefault()">
              <a-icon type="more" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                 <router-link :to="{path:'/Register'}"> 重新登记 </router-link>  
              </a-menu-item>
            </a-menu>
          </a-dropdown>

          <a-icon type="right" class="ml12 gray" @click="onTabelRowClick(scope.row)" /> -->

          <router-link class="myDCIBtn" :to="{path:'/Mine/EvaluateDetail',query: {orderNo: scope.row.orderNo}}" target="_blank"> 详情 </router-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, sizes, prev, pager, next"
     :total="pagination.total"
      :current-page.sync="pagination.page"
      :page-size.sync="pagination.pageSize"
      @size-change="sizeChange"
      @current-change="currentChange"
      :pagerCount="5" 
    >
    </el-pagination>


      <!-- 图片预览 -->
      <el-image-viewer
        v-if="showImageViewer"
        :url-list="[showImageUrl]"
        hide-on-click-modal
        teleported
        :on-close="closePre"
      />
      <el-image-viewer
        v-if="showImageViewer2"
        :url-list="[showImageUrl2]"
        hide-on-click-modal
        teleported
        :on-close="closePre2"
      />
      <el-image-viewer
        v-if="showImageViewer3"
        :url-list="[showImageUrl3]"
        hide-on-click-modal
        teleported
        :on-close="closePre3"
      />

      <pay-dialog ref="payDialog" @close="onSetPayDialogClose"></pay-dialog>
  </div>
</template>

<script>
import {queryEvaluationList,queryRegisterOrder,queryExistOrder,queryEvaluationDetail} from '@/api/EvidenceService'
import PayDialog from "../../../components/PayDialog";

export default {
  name: 'MyRegister',
  components: {
      'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
      PayDialog
  },
  data () {
    return {
      form: {
        workName: null,
        keywords: null,
        date: null
      },
      isLoading: false,
      pagination: {
         total:0,
        page: 1,
        pageSize: 10
      },
      tableData:[],
      
      showImageViewer: false,
      showImageUrl: '',
      showImageViewer2: false,
      showImageUrl2: '',
      showImageViewer3: false,
      showImageUrl3: '',
    }
  },
  created() {
    this.fetchData();
  },
  activated() { // 每次进入页面时调用数据获取方法
    this.fetchData()
  },
  methods: {
    onTabelRowClick(row){
      this.$router.push({
        path: "/Register/Detail",
            query: {orderNo:row.orderNo}
      });
    },
    tabelCellClass ({ row, column, rowIndex, columnIndex }) {
      if (column.property == 'certificate') {
        return 'certificateCell'
      }
    },
    getStatus(code){
        switch(code){
          case '10':return '待付款';
          case '11':return '待审核';
          case '20':return '已审核';
          case '21':return '已完成';
          case '31':return '失败';
          case '40':return '已取消';
        }
    },
    fetchData (param) {
      this.isLoading = true
        queryEvaluationList(this.pagination.page,this.pagination.pageSize,this.form).then(({data})=>{
            for (let i = 0; i < data.list.length; i++) {
            const element = data.list[i];
             element.num=element.items.length;
             element.statusText=this.getStatus(element.status);
              element.createTimeText= this.dayjs(element.createTime*1000).format('YYYY-MM-DD');
      // this.orderInfo.updateTimeText= this.dayjs(this.orderInfo.updateTime*1000).format('YYYY-MM-DD HH:mm:ss ');         
          }
          this.tableData=data.list;
          this.pagination.total=data.total*1;
          this.isLoading = false
          
        });
    },
    sizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum = 1
      this.fetchData()
    },
    currentChange (pageNum) {
      // 更新表格数据
      this.fetchData()
    },


    // 放大证书
    getRegisterImg(orderNo){
      queryRegisterOrder(orderNo).then(({ data }) => {
        // console.log("登记详情：",data);
        document.body.style.overflow = 'hidden';
        this.showImageUrl = data.certificateInfo.jpgUrl;
        this.showImageViewer = true;
      })
    },
    closePre(){
      document.body.style.overflow = 'auto';
      this.showImageUrl = '';
      this.showImageViewer = false;
    },


    // 获取存证图片
    getExistImg(orderNo){
      // console.log(orderNo);
      queryExistOrder(orderNo).then(({ data }) => {
        // console.log("存证详情：",data);
        document.body.style.overflow = 'hidden';
        this.showImageUrl2 = data.certificateInfo.jpgUrl;
        this.showImageViewer2 = true;
      })
    },
    closePre2(){
      document.body.style.overflow = 'auto';
      this.showImageUrl2 = '';
      this.showImageViewer2 = false;
    },

    // 获取评价证书图片
     getEvaluateImg(orderNo){
       queryEvaluationDetail(orderNo).then(({ data }) => {
        document.body.style.overflow = 'hidden';
        this.showImageUrl3 = data.certificateInfo.jpgUrl;
        this.showImageViewer3 = true;
       })
     },
     closePre3(){
      document.body.style.overflow = 'auto';
      this.showImageUrl3 = '';
      this.showImageViewer3 = false;
    },
    
    onSetPayDialogClose(result) {
      console.log(result);
      if (result) {
        this.loadData();
      }
    },
  }
}
</script>

<style lang='scss' scoped>
@import '../../../assets/css/mine.scss';
.myDCIBtn{color: #1884FF;background: transparent;padding: 0;border: none;margin: 0;display: inline-block;}
.myDCIBtn:nth-child(1){margin-right: 15px;}
.myDCIBtn:hover,.myDCIBtn:focus{background: transparent;}
.myDCIBtn2{background: transparent;padding: 0;border: none;margin: 0;display: inline-block;}
.myDCIBtn2:hover{background: transparent;color: #C0C4CC;}
.myDCIBtn:disabled{color: #C0C4CC;}

@media screen and (max-width: 991px){
    .serviceMain{padding: 20px;}
    .searchBar{display: block;}
    .searchBar .tittle{margin-bottom: 10px;}
  }
</style>
